import axios from "./interceptor";
import { BASE_URL } from "../constant";
import {
    SHOW_SUCCESS,SHOW_ACCESSORY_MAPPING_UPLOAD_DIALOG,
    HIDE_ACCESSORY_MAPPING_UPLOAD_DIALOG
} from "./types";
import { handleError } from "../utils/utils";

export const batchCreateAccessoryMapping = (accessoryMappings) => async dispatch => {
    console.log("Posting "+ JSON.stringify(accessoryMappings) );
    axios.post(`${BASE_URL}/current/article/accessoryMapping/upload`, accessoryMappings)
        .then(response => {
            dispatch({
                type: SHOW_SUCCESS,
                payload: {
                    message: 'messages.user.fileUploaded',
                    dialogType: 'info',
                    refresh: true
                }
            })
        }).catch(error => {
            handleError(error, dispatch)
    })
}

export const showAccessoryMappingUploadDialog = (entity) => {
    return({
        type: SHOW_ACCESSORY_MAPPING_UPLOAD_DIALOG,
        payload: {
            entity: entity
        }
    })
}

export const hideAccessoryMappingUploadDialog = () => {
    return ({
        type: HIDE_ACCESSORY_MAPPING_UPLOAD_DIALOG
    })
}